const DEBUG = true;

export const log = DEBUG ? console.log.bind(console) : function () {};
